import React from 'react';
import { Trans } from '@lingui/macro';

import Container from '@src/components/Container';
import Divider from '@src/components/Divider';
import RefreshControl from '@src/components/RefreshControl';
import Separator from '@src/components/Separator';
import { Body1 } from '@src/components/Typography';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import { Discount } from '@src/types';

import DiscountCard from './DiscountCard';
import { Heading, List } from './styled';
import { Props } from './types';
import useUserDiscounts from './useUserDiscounts';
import useUserWallet from './useUserWallet';

const Screen: React.FC<Props> = () => {
  const userWallet = useUserWallet();
  const userDiscounts = useUserDiscounts();
  const handleScroll = useAnimatedHeader();

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          onScroll={handleScroll}
          ListHeaderComponent={
            <Heading>
              <Separator />

              <Body1>
                <Trans>Your wallet remaining balance</Trans>
              </Body1>
              <Body1>{userWallet.data?.amount}</Body1>

              {userWallet.data?.currency === 'RIAL' ? (
                <Body1>
                  <Trans>Rial</Trans>
                </Body1>
              ) : (
                <Body1>{userWallet.data?.currency}</Body1>
              )}

              <Separator />
              <Divider />
              <Separator />

              <Body1>
                <Trans>Your discounts for purchasing tours</Trans>
              </Body1>

              <Separator />
            </Heading>
          }
          refreshControl={
            <RefreshControl
              refreshing={userDiscounts.refreshing}
              onRefresh={userDiscounts.handleRefresh}
            />
          }
          renderItem={({ item }: { item: Discount }) => (
            <DiscountCard data={item} />
          )}
          data={userDiscounts.data}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'Wallet';

export default Screen;
